import { initialState, CostTrackerState } from "./state";
import { Actions } from './actions';
import {
    COST_TRACKERS_LIST, COST_TRACKER_BY_ID, CLOUD_PROVIDERS_LIST, SAVE_COST_TRACKER_RESP, DELETE_COST_TRACKER_RESP,
    GET_ALL_EVENTS_RESP, GET_EVENT_INFO_RESP, SAVE_EVENT_RESP, SET_COST_TRACKER_CONTRACTS, COST_TRACKER_BY_FIELD_LIST
} from "./actionTypes";
import { SortListAscending } from "app/utils/sort.util";

export function CostTrackerReducer(state = initialState, action: Actions): CostTrackerState {
    switch (action.type) {
        case COST_TRACKERS_LIST:
            return Object.assign({}, state, {
                costTrackersList: SortListAscending(action.payload, "name")
            });
        case COST_TRACKER_BY_FIELD_LIST:
            return Object.assign({}, state, {
                costTrackersByFieldList: SortListAscending(action.payload, "name")
            });
        case COST_TRACKER_BY_ID:
            return Object.assign({}, state, {
                costTrackerById: action.payload
            });
        case SAVE_COST_TRACKER_RESP:
            return Object.assign({}, state, {
                saveCostTrackerResp: action.payload
            });
        case DELETE_COST_TRACKER_RESP:
            return Object.assign({}, state, {
                deleteCostTrackerResp: action.payload
            });
        case CLOUD_PROVIDERS_LIST:
            return Object.assign({}, state, {
                cloudProvidersList: action.payload
            });
        case SET_COST_TRACKER_CONTRACTS:
            return Object.assign({}, state, {
                costTrackerContracts: action.payload
            });
        case GET_ALL_EVENTS_RESP:
            return Object.assign({}, state, {
                eventsForTracker: [...state.eventsForTracker, action.payload]
            });
        case GET_EVENT_INFO_RESP:
            return Object.assign({}, state, {
                eventInfo: action.payload
            });
        case SAVE_EVENT_RESP:
            return Object.assign({}, state, {
                saveEventResp: action.payload
            });
        default:
            return state;
    }
}
